import { VFC } from 'react'
import {
  TimelineContribution,
  TimelineContributionSP,
  TimelineGuideLink,
  TimelineMessage,
  TimelineMessageSP,
  TimelineRecommend,
  TimelineRecommendSP,
  TimelineSearch,
  TimelineSearchSP,
} from 'src/assets/svgs'
import { Link } from 'src/elements/Link'
import { _contributiontext, _menuicon, orange } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import {
  GUIDE_LINK,
  MESSAGES,
  NEEDS,
  PREMIUM_CONTRIBUTIONS,
  RECOMMEND,
} from 'src/utils/routes'
import styled from 'styled-components'

export const OnlyStoryGuide: VFC<{ hasPaid: boolean }> = ({ hasPaid }) => (
  <GuideLayout>
    <GuideContainer>
      <GuideTop>
        <GuideTitle>
          <GuideTitleSpan>\</GuideTitleSpan> ONLY STORYを活用しよう{' '}
          <GuideTitleSpan>/</GuideTitleSpan>
        </GuideTitle>
      </GuideTop>
      <GuideTitleSub href={GUIDE_LINK} target="_blank">
        <p>
          プラットフォームの使い方を
          <br />
          知りたい方はこちら
        </p>
        <TimelineGuideLinkIcon>
          <TimelineGuideLink />
        </TimelineGuideLinkIcon>
      </GuideTitleSub>
    </GuideContainer>
    <GuideContentPC>
      <GuideContentLink href={MESSAGES}>
        <TimelineMessage />
      </GuideContentLink>
      <GuideContentLink href={RECOMMEND}>
        <TimelineRecommend />
      </GuideContentLink>
      <GuideContentLink href={PREMIUM_CONTRIBUTIONS}>
        <TimelineContribution />
      </GuideContentLink>
      {hasPaid && (
        <GuideContentLink href={NEEDS}>
          <TimelineSearch />
        </GuideContentLink>
      )}
    </GuideContentPC>
    <GuideContentSP>
      <GuideContentLinkSP href={MESSAGES}>
        <TimelineMessageSP />
      </GuideContentLinkSP>
      <GuideContentLinkSP href={RECOMMEND}>
        <TimelineRecommendSP />
      </GuideContentLinkSP>
      <GuideContentLinkSP href={PREMIUM_CONTRIBUTIONS}>
        <TimelineContributionSP />
      </GuideContentLinkSP>
      {hasPaid && (
        <GuideContentLinkSP href={NEEDS}>
          <TimelineSearchSP />
        </GuideContentLinkSP>
      )}
    </GuideContentSP>
  </GuideLayout>
)

const GuideLayout = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
`

const GuideContainer = styled.div`
  position: relative;
`

const GuideTop = styled.div`
  display: flex;
  justify-content: center;
`

const GuideTitle = styled.h1`
  font-size: 32px;
  @media screen and (max-width: 960px) {
    font-size: 18px;
  }
  font-weight: ${fontWeightBold};
  text-align: center;
`
const GuideTitleSpan = styled.span`
  font-weight: ${fontWeightBold};
  font-size: 40px;
  color: ${orange};
`

const GuideTitleSub = styled.a`
  position: absolute;
  top: 0px;
  right: 0;

  font-size: 12px;
  text-align: center;
  line-height: 24px;
  font-weight: ${fontWeightBold};
  color: ${_contributiontext};
  display: flex;
  justify-content: center;
  p {
    margin-right: 8px;
  }
  @media screen and (max-width: 960px) {
    display: none;
  }
`

const TimelineGuideLinkIcon = styled.div`
  margin-top: 12px;
`

const GuideContentPC = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 960px) {
    display: none;
  }
`
const GuideContentLink = styled(Link)`
  cursor: pointer;
  margin: 0 8px;
`
const GuideContentSP = styled.div`
  @media screen and (min-width: 960px) {
    display: none;
  }
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* 要素を折り返し */
  padding: 12px 0 20px;
  border-bottom: 1px solid ${_menuicon};
`
const GuideContentLinkSP = styled(Link)`
  min-width: 169px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5; /* 背景色 (任意) */
  border-radius: 8px; /* 角丸 (任意) */
  text-align: center;
  padding: 4px 8px;
`
